addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-task-form]').forEach(form => {
        const editor = form.querySelector('[data-task-editor]');
        if (!editor) return;
        const rowSelector = '[data-task-simple-row], [data-task-row]';
        const planQuantities = new Map();
        JSON.parse(editor.dataset.taskPlan || '[]').forEach(row => {
            const key = JSON.stringify([String(row.product), row.action, row.condition]);
            planQuantities.set(key, (planQuantities.get(key) || 0) + Number(row.quantity));
        });
        const updatePlannedQuantity = row => {
            const cell = row.querySelector('[data-task-plan-quantity]');
            if (!cell) return;
            const product = row.querySelector('select[name$="[product]"]').value;
            const action = row.querySelector('[data-task-action]').value;
            const condition = row.querySelector('[data-task-condition]').value;
            const key = JSON.stringify([product, action, condition]);
            cell.textContent = planQuantities.get(key) || 0;
        };
        const existingIndexes = Array.from(editor.querySelectorAll('[name]'), input => {
            return Number(input.name.match(/\[lines\]\[(\d+)\]/)?.[1] ?? -1);
        });
        let nextIndex = Math.max(-1, ...existingIndexes) + 1;

        const updateCondition = row => {
            const action = row.querySelector('[data-task-action]').value;
            const select = row.querySelector('[data-task-condition]');
            const fixed = row.querySelector('[data-task-fixed-condition]');
            const hasFixedCondition = action === 'restore' || action === 'damage';
            if (hasFixedCondition) {
                select.value = action === 'restore' ? 'damaged' : 'normal';
                fixed.textContent = select.selectedOptions[0]?.textContent ?? '';
            }
            select.hidden = hasFixedCondition;
            fixed.hidden = !hasFixedCondition;
        };
        const prepareRow = (row, action = null) => {
            const actionSelect = row.querySelector('[data-task-action]');
            if (action) {
                row.removeAttribute('data-task-simple-row');
                row.setAttribute('data-task-row', '');
                actionSelect.value = action;
                row.querySelector('[data-task-action-cell]').hidden = true;
            } else {
                Array.from(actionSelect.options).forEach(option => {
                    if (option.value.startsWith('transform_')) option.remove();
                });
            }
            updateCondition(row);
        };
        const validate = () => {
            const transform = editor.querySelector('[data-task-transform]');
            const addTransform = editor.querySelector('[data-task-add-transform]');
            addTransform.hidden = !!transform;
            addTransform.disabled = !!transform;
            editor.querySelector('[data-task-transform-present]').checked = !!transform;
            const rows = Array.from(editor.querySelectorAll(rowSelector));
            rows.forEach(row => {
                updatePlannedQuantity(row);
                const select = row.querySelector('select[name$="[product]"]');
                const action = row.querySelector('[data-task-action]').value;
                const condition = row.querySelector('[data-task-condition]').value;
                const isTransform = action.startsWith('transform_');
                const duplicates = rows.filter(other => {
                    if (other === row) return false;
                    const otherAction = other.querySelector('[data-task-action]').value;
                    const otherCondition = other.querySelector('[data-task-condition]').value;
                    return isTransform ? otherAction.startsWith('transform_') :
                        otherAction === action && otherCondition === condition;
                }).map(other => other.querySelector('select[name$="[product]"]').value).filter(Boolean);
                const duplicateMessage = isTransform ? 'В преобразовании каждый товар можно указать только один раз.' :
                    'Товар с этим действием и состоянием уже указан.';
                select.setCustomValidity(select.value && duplicates.includes(select.value) ? duplicateMessage : '');
                Array.from(select.options).forEach(option => {
                    option.disabled = option.value !== '' && option.value !== select.value && duplicates.includes(option.value);
                });
            });
            if (transform) {
                const missingSide = Array.from(transform.querySelectorAll('[data-task-rows]')).some(section => {
                    return !section.querySelector('[data-task-row]');
                });
                transform.querySelector('[data-task-transform-error]').hidden = !missingSide;
                const message = missingSide ? 'В преобразовании укажите товары для использования и получения.' : '';
                transform.querySelector('[data-task-transform-validity]').setCustomValidity(message);
            }
        };
        const addRow = (target, action = null) => {
            const holder = document.createElement('template');
            holder.innerHTML = editor.querySelector('[data-task-row-template]').innerHTML.replaceAll('__name__', nextIndex++);
            const row = holder.content.querySelector(rowSelector);
            prepareRow(row, action);
            target.appendChild(holder.content);
        };
        editor.querySelectorAll(rowSelector).forEach(row => {
            const action = row.querySelector('[data-task-action]').value;
            prepareRow(row, action.startsWith('transform_') ? action : null);
        });
        validate();
        form.addEventListener('change', event => {
            if (event.target.matches('[data-task-action]')) updateCondition(event.target.closest(rowSelector));
            validate();
        });
        form.addEventListener('click', event => {
            const button = event.target.closest('button');
            if (!button) return;
            if (button.matches('[data-task-add-simple]')) addRow(editor.querySelector('[data-task-simple-list]'));
            if (button.matches('[data-task-remove-row]')) button.closest(rowSelector).remove();
            if (button.matches('[data-task-add-transform]') && !editor.querySelector('[data-task-transform]')) {
                const block = editor.querySelector('[data-task-transform-template]').content.cloneNode(true);
                editor.querySelector('[data-task-transforms]').appendChild(block);
            }
            if (button.matches('[data-task-remove-transform]')) button.closest('[data-task-transform]').remove();
            if (button.matches('[data-task-add-row]')) {
                const section = button.closest('[data-task-rows]');
                addRow(section.querySelector('[data-task-row-list]'), section.dataset.action);
            }
            validate();
        });
    });
});
